//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
//import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
//import { ProductsLoaded } from 'redux/actions';

//firebase
import { db } from 'assets/firebase';

// @material-ui/style
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";

//materialKit components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomSelect from "components/Select/Select.jsx";

//icons
import Preview from "@material-ui/icons/Launch";

//ATEQ
import LessonEditor from "components/LessonEditor/LessonEditor.jsx";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

class LessonList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lessons: [],
      courseOptions: [],
    }

    var courses = []; 
    for(var i = 0; i < this.props.courses.length; i++) {
        courses.push({key:this.props.courses[i].id, label:this.props.courses[i].Name});
        if(this.props.courses[i].id === "BmeqwyOBaiYFxePx6icj") {//hard-coded to grades 2-3 for now 
          this.state.selectedCourse = {key: this.props.courses[i].id, label: this.props.courses[i].Name };
        }
    }
    this.state.courseOptions = courses;
    //this.state.selectedCourse = courses[0];

    this.lessonUpdated = this.lessonUpdated.bind(this);
  }

  componentDidMount() {
    this.refreshLessons(this.state.selectedCourse.key);
  }

  lessonUpdated() {
    this.refreshLessons(this.state.selectedCourse);
  }

  refreshLessons(courseID) {

    this.setState({selectedCourse: courseID, lessons: []}, function() {

      db.getLessons(courseID).then(snapshot => {
            
        var lessons = [];
        snapshot.forEach((doc) => {

            var lesson = doc.data();
            lesson.id = doc.id;
            if(!lesson.Attachments)
              lesson.Attachments = [];
            if(!lesson.Photos)
              lesson.Photos = [];
            if(!lesson.Video)
              lesson.Video = "";
            lessons.splice(0, 0, lesson);

            this.setState({lessons: lessons});
        });
      });
    });
  }
  
  previewLesson(lesson) {
    var url = 'https://app.allthingseq.com/lesson/' + lesson.id
    window.open(url);
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    ReactGA.pageview("admin.allthingseq.com/lessons");

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <GridContainer>
                <GridItem xs={12} sm={12} md={10}>
                  <h4 className={classes.cardTitleWhite}>Lessons</h4>
                  <p className={classes.cardCategoryWhite}>
                    
                  </p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2} style={{textAlign:"right"}}>
                  <Tooltip
                        id="tooltip-top-start"
                        title="Add Lesson"
                        placement="top"
                        classes={{ tooltip: classes.tooltip }}
                    >
                      <LessonEditor onChange={this.lessonUpdated} 
                        course={this.state.selectedCourse}
                        lesson={{
                          Name: "",
                          Description: "",
                          Attachments:[],
                          Photos: [],
                          Quarter: 1,
                          Week: 1,
                          Video: "",
                          orgId: this.props.org.id
                        }} />
                  </Tooltip>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
            <GridContainer>
                <GridItem xs={1} sm={8}>&nbsp;</GridItem> 
                <GridItem xs={11} sm={4}  >
                  <CustomSelect
                      labelText="Course"
                      inputProps={{ placeholder: "Choose a Course" }}
                      formControlProps={{ fullWidth: true }}
                      onChange={(e) => this.refreshLessons(e.target.value)}
                      options={this.state.courseOptions}
                      value={this.state.selectedCourse}
                    />
                    
                </GridItem>
              </GridContainer>
              <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                      <TableCell style={{paddingRight:"3px"}}>

                      </TableCell>
                      <TableCell>
                        Quarter
                      </TableCell>
                      <TableCell>
                        Week
                      </TableCell>
                      <TableCell>
                        Title
                      </TableCell>
                      <TableCell style={{padding:"3px"}}>

                      </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.lessons.map(value => (
                    <TableRow key={value.id} className={classes.tableRow}>
                      <TableCell className={classes.tableActions} style={{paddingRight:"3px"}}>
                        <Tooltip
                          id="tooltip-top"
                          title="Edit Lesson"
                          placement="top"
                          classes={{ tooltip: classes.tooltip }}
                        >
                         <LessonEditor lesson={value} onChange={this.lessonUpdated} />
                        </Tooltip>
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.Quarter}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.Week}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.Name}
                      </TableCell>
                      <TableCell style={{padding:"3px"}}>
                        <IconButton onClick={() => this.previewLesson(value)}>
                          <Preview />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}/*
function mapDispatchToProps(dispatch) {
  return bindActionCreators({onProductsLoaded: ProductsLoaded }, dispatch);  
}*/

LessonList = connect(mapStateToProps)(LessonList);
export default withStyles(styles)(LessonList);



// WEBPACK FOOTER //
// ./src/views/LessonList/LessonList.jsx